<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Bruno Giacosa</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Se non conosci il nome di questo fantastico produttore, continua a leggere; ti aspetta una sorpresa.
                        Bruno Giacosa, purtroppo scomparso all'inizio del 2018, era considerato uno dei più grandi vini italiani
                        produttori di tutti i tempi. Il suo vigneto Falletto a Serralunga d'Alba è uno dei migliori cru di
                        delle Langhe, il suo perfezionismo era leggendario e molti i suoi riconoscimenti. Per dire che lo era
                        La regalità del vino italiano è un eufemismo. Creatore del "miglior vino italiano di sempre" - un Santo del 1971
                        Stefano Barbaresco Riserva Speciale - quando il grande uomo è morto, l'Italia ha pianto.
                    </div>

                    <div class="howto-title2">Un leader tra gli uomini</div>
                    <div class="howto-text">
                        Come molte leggende piemontesi (mi viene in mente Angelo Gaja), Giacosa è arrivato tardi a possedere il terroir.
                        Ha iniziato la sua lunga e illustre carriera aiutando il nonno nella tenuta di famiglia al
                        a soli 13 anni. Nel 1960 prende in mano le redini dell'azienda e, pur essendo ancora
                        acquistando frutta da altri contadini, rivoluzionò il modo di pensare della regione imbottigliando il suo Barolo
                        e Barbaresco in loco, aprendo la strada a molti altri. Non è stato fino all'età di 50 anni che lui
                        divenne proprietario terriero a pieno titolo e il suo famoso perfezionismo non si fermò qui. Senza paura di
                        declassificare intere vendemmie (la sua annata 2006 serve da esempio), per dire che Bruno Giacosa lo è
                        responsabile di alcuni dei migliori vini italiani di sempre non sarebbe altro che la verità.
                    </div>

                    <div class="howto-title2">Un concorrente per il vino più costoso d'Italia?</div>
                    <div class="howto-text">
                        I suoi singoli vini da vigneto sono leggendari. Michaela Morris, esperta di vini italiani per Decanter
                        dice la rivista, “la bottiglia più memorabile è stata il suo Barbaresco Santo Stefano Riserva del 1978
                        Speciale. Mi è stato servito alla cieca nel 2012 e ho quasi pianto per la sua pura bellezza inquietante.
                        Quando il vino è stato rivelato, credo di averlo fatto. Non solo questa bottiglia estremamente rara è estremamente
                        difficile da trovare, ma è anche estremamente costoso. A partire dal 2019, è stato possibile reperire solo una bottiglia
                        sul mercato aperto e aveva un prezzo di € 3.250. Il 1971 non è in vendita.
                        <br><br>
                        Nonostante sia ancora molto presto dopo la scomparsa del grande uomo, le sue figlie Bruna e
                        Marina che oggi gestisce la vigna sembra aver ereditato il dna d'oro della famiglia. Bruna lo è stata
                        al timone della cantina dal 2006, quindi crediamo fermamente che l'eredità di suo padre sia ben curata
                        Dopo.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Barolo Falletto 2014: questa “eccezionale” uscita attuale si fa notare per il suo “Grande senso
                                di terroir e armonia e stile tipici di questo produttore. Alcuni anni offriranno
                                maggiore complessità, in quanto gli aromatici sono un po' serrati fin d'ora. Picco tra 15-20 anni”. di
                                lo scrittore di vini Tom Hyland per Forbes, aprile 2019. A giugno 2018 Monica Larner per Wine
                                L'avvocato le ha offerto 95 punti. I prezzi sono aumentati del +50% nel periodo di un anno da febbraio
                                2018 e l'arrampicata.
                            </li>
                            <li>Etichettato "Riserva" solo nelle migliori annate, il Barolo Riserva Collina Rionda 1989 di Bruno Giacosa è stato il primo vino pregiato italiano a ricevere un "Punteggio perfetto" di 100/100 dall'uomo stesso, Robert Parker.
                            </li>
                            <li>Prezzi storicamente rispetto ai vini di seconda crescita di Bordeaux, si prevede il Barolo
                                riconquistare la sua posizione di primo piano per i vini pregiati italiani nel mercato, come indicato a gennaio
                                2019 dal capo del trading di The Drinks Business, Paul Regan, che raccomanda agli investitori “Stick
                                a grandi nomi come Giacomo Conterno e Bruno Giacosa e dovresti fare piuttosto bene”.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Bruno Giacosa</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn Sie den Namen dieses fantastischen Produzenten nicht kennen, lesen Sie weiter. du bekommst eine Belohnung.
                        Bruno Giacosa, der Anfang 2018 leider verstarb, galt als einer der größten Weine Italiens
                        Produzenten aller Zeiten. Sein Falletto-Weinberg in Serralunga d’Alba ist einer der besten Crus der Welt
                        der Langhe, sein Perfektionismus war legendär und seine Auszeichnungen zahlreich. Zu sagen, dass er es war
                        Italienische Weinkönige sind eine Untertreibung. Hersteller von „Italiens bestem Wein aller Zeiten“ – einem Santo von 1971
                        Stefano Barbaresco Riserva Speciale – als der große Mann starb, trauerte Italien.
                    </div>

                    <div class="howto-title2">Ein Anführer unter Männern</div>
                    <div class="howto-text">
                        Wie viele piemontesische Legenden (da fällt mir Angelo Gaja ein) kam Giacosa erst spät dazu, Terroir zu besitzen.
                        Er begann seine lange und glänzende Karriere damit, dass er seinem Großvater auf dem Familienanwesen half
                        Im Alter von gerade einmal 13 Jahren übernahm er 1960 die Leitung des Unternehmens, und das, obwohl er noch aktiv war
                        Er kaufte Obst von anderen Bauern und revolutionierte das Denken der Region, indem er seinen Barolo in Flaschen abfüllte
                        und Barbaresco vor Ort und ebnete den Weg für viele andere. Erst als er 50+ war, wurde er
                        wurde selbst Landbesitzer und sein berühmter Perfektionismus endete damit noch nicht. Keine Angst davor
                        ganze Ernten freigeben (als Beispiel dient sein Jahrgang 2006), um zu sagen, dass Bruno Giacosa dies ist
                        für einige der besten Weine Italiens verantwortlich zu sein, wäre nichts anderes als die Wahrheit.
                    </div>

                    <div class="howto-title2">Ein Anwärter auf Italiens teuersten Wein?</div>
                    <div class="howto-text">
                        Seine Einzellagenweine sind legendär. Michaela Morris, italienische Weinexpertin für Decanter
                        In der Zeitschrift heißt es: „Die unvergesslichste Flasche war sein 1978er Barbaresco Santo Stefano Riserva.“
                        Besonderes. Es wurde mir 2012 blind serviert und ich weinte fast wegen seiner eindringlichen Schönheit.
                        Als der Wein enthüllt wurde, glaube ich, dass ich es getan habe.“ Diese äußerst seltene Flasche ist nicht nur äußerst selten
                        schwer zu finden, aber auch extrem teuer. Ab 2019 konnte nur eine Flasche bezogen werden
                        auf dem freien Markt und kostete 3.250 €. Der 1971er steht nicht zum Verkauf.
                        <br><br>
                        Obwohl es nach dem Tod des großen Mannes noch sehr früh ist, haben seine Töchter Bruna und
                        Marina, die heute das Weingut leitet, scheint die goldene DNA der Familie geerbt zu haben. Bruna war
                        Sie steht seit 2006 an der Spitze des Weinguts und ist daher fest davon überzeugt, dass das Erbe ihres Vaters gut gepflegt wird
                        nach.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>2014 Barolo Falletto: Diese „herausragende“ aktuelle Veröffentlichung ist für ihren „großartigen Sinn“ bekannt
                                des Terroirs und der typischen Harmonie und des Stils dieses Produzenten. Ein paar Jahre werden reichen
                                größere Komplexität, da die Aromatik derzeit etwas eng ist. Höhepunkt in 15–20 Jahren.“ von
                                Weinautor Tom Hyland für Forbes, April 2019. Im Juni 2018 Monica Larner für Wine
                                Der Anwalt bot ihr 95 Punkte. Die Preise sind im Einjahreszeitraum seit Februar um +50 % gestiegen
                                2018 und Klettern.
                            </li>
                            <li>Bruno Giacosas Barolo Riserva Collina Rionda aus dem Jahr 1989, der nur in den besten Jahrgängen mit der Bezeichnung „Riserva“ ausgezeichnet wurde, war der erste italienische Edelwein, der vom Mann selbst, Robert Parker, eine „Perfect Score“ von 100/100 erhielt.
                            </li>
                            <li>Im historischen Vergleich zu den Weinen des Bordeaux-Zweitgewächses wird erwartet, dass der Preis für Barolo höher ausfällt
                                Wie bereits im Januar angekündigt, erobert sich das Unternehmen seine Spitzenposition für italienische Spitzenweine auf dem Markt zurück
                                2019 von Paul Regan, Handelsleiter von The Drinks Business, der Anlegern „Stick
                                zu großen Namen wie Giacomo Conterno und Bruno Giacosa und du solltest ziemlich gut abschneiden.“
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Bruno Giacosa</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Si vous ne connaissez pas le nom de ce fantastique producteur, lisez la suite ; vous allez vous régaler.
                        Bruno Giacosa, malheureusement décédé début 2018, était considéré comme l'un des plus grands vins d'Italie
                        producteurs de tous les temps. Son vignoble de Falletto à Serralunga d'Alba est l'un des plus beaux crus de
                        Langhe, son perfectionnisme était légendaire et ses distinctions nombreuses. Dire qu'il était
                        La royauté du vin italien est un euphémisme. Créateur du "meilleur vin d'Italie" - un Santo de 1971
                        Stefano Barbaresco Riserva Speciale - lorsque le grand homme est décédé, l'Italie a pleuré.
                    </div>

                    <div class="howto-title2">Un leader parmi les hommes</div>
                    <div class="howto-text">
                        Comme beaucoup de légendes piémontaises (Angelo Gaja vient à l'esprit), Giacosa est arrivé tardivement à posséder un terroir.
                        Il a commencé sa longue et illustre carrière en aidant son grand-père sur le domaine familial à la
                        13 ans à peine. En 1960, il prend les rênes de l'entreprise et, bien qu'il soit encore
                        achetant des fruits à d'autres agriculteurs, il a révolutionné la façon de penser de la région en embouteillant son Barolo
                        et Barbaresco sur place, ouvrant la voie à bien d'autres. Ce n'est qu'à l'âge de 50 ans et plus qu'il
                        est devenu propriétaire terrien à part entière et son célèbre perfectionnisme ne s'est pas arrêté là. Sans peur de
                        déclasser des récoltes entières (son millésime 2006 sert d'exemple), dire que Bruno Giacosa est
                        responsable de certains des meilleurs vins italiens de tous les temps ne serait que la vérité.
                    </div>

                    <div class="howto-title2">Un concurrent pour le vin le plus cher d'Italie?</div>
                    <div class="howto-text">
                        Ses vins de terroir sont légendaires. Michaela Morris, experte en vins italiens pour Decanter
                        magazine dit, "la bouteille la plus mémorable était son 1978 Barbaresco Santo Stefano Riserva
                        Spéciale. Il m'a été servi à l'aveugle en 2012 et j'ai presque pleuré pour sa beauté envoûtante.
                        Quand le vin a été révélé, je crois que oui. Non seulement cette bouteille extrêmement rare est extrêmement
                        difficile à trouver, mais c'est aussi extrêmement cher. À partir de 2019, une seule bouteille pouvait être achetée
                        sur le marché libre et son prix était de 3 250 €. Le 1971 n'est pas à vendre.
                        <br><br>
                        Bien qu'il soit encore très tôt après la disparition du grand homme, ses filles Bruna et
                        Marina qui dirige aujourd'hui le vignoble semble avoir hérité de l'ADN doré de la famille. Bruna a été
                        à la tête de la cave depuis 2006, nous croyons donc fermement que l'héritage de son père est bien vu
                        après.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Barolo Falletto 2014: cette version actuelle "exceptionnelle" se distingue par son "grand sens
                                de terroir et d'harmonie et de style typiques de ce producteur. Quelques années offriront
                                une plus grande complexité, car les arômes sont un peu serrés pour l'instant. Pic dans 15-20 ans. par
                                écrivain vin Tom Hyland pour Forbes, avril 2019. En juin 2018 Monica Larner pour Wine
                                L'avocat lui a offert 95 points. Les prix sont en hausse de +50% sur la période d'un an à partir de février
                                2018, et escalade.
                            </li>
                            <li>Labellisé "Riserva" uniquement dans les meilleurs millésimes, le Barolo Riserva Collina Rionda de Bruno Giacosa de 1989 a été le tout premier vin italien fin à recevoir une "Score parfaite" de 100/100 de l'homme lui-même, Robert Parker.
                            </li>
                            <li>Des prix historiquement comparés aux seconds crus de Bordeaux, le Barolo devrait
                                reconquérir sa position de leader pour les vins fins italiens sur le marché, comme indiqué en janvier
                                2019 par le responsable du trading de The Drinks Business, Paul Regan, qui recommande aux investisseurs "Stick
                                à de grands noms comme Giacomo Conterno et Bruno Giacosa et vous devriez plutôt bien vous débrouiller.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Bruno Giacosa</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        If you do not know the name of this fantastic producer then read on; you're in for a treat.
                        Bruno Giacosa, who sadly died in early 2018, was considered one of Italy’s greatest wine
                        producers of all time. His Falletto vineyard in Serralunga d’Alba is one of the finest crus of
                        the Langhe, his perfectionism was legendary and his accolades were many. To say that he was
                        Italian wine royalty is an understatement. Maker of “Italy’s best-ever wine” - a 1971 Santo
                        Stefano Barbaresco Riserva Speciale - when the great man passed, Italy mourned.
                    </div>

                    <div class="howto-title2">A leader among men</div>
                    <div class="howto-text">
                        Like many Piedmont legends (Angelo Gaja springs to mind), Giacosa came late to owning terroir.
                        He began his long and illustrious career by helping his grandfather on the family estate at the
                        age of just 13. In 1960 he took hold of the reins of the business and, although he was still
                        buying fruit from other farmers, he revolutionised the region’s thinking by bottling his Barolo
                        and Barbaresco on site, paving the way for many others. It was not until he was 50+ that he
                        became a land-owner in his own right and his famed perfectionism didn’t stop there. Unafraid to
                        declassify entire harvests (his 2006 vintage serves as an example), to say that Bruno Giacosa is
                        responsible for some of Italy’s best ever wines would be nothing but the truth.
                    </div>

                    <div class="howto-title2">A contender for Italy’s most expensive wine?</div>
                    <div class="howto-text">
                        His single vineyard wines are legendary. Michaela Morris, Italian wine expert for Decanter
                        magazine says, “the most memorable bottle was his 1978 Barbaresco Santo Stefano Riserva
                        Speciale. It was served to me blind in 2012 and I almost wept for its sheer haunting beauty.
                        When the wine was revealed I believe I did.” Not only is this extremely rare bottle extremely
                        hard to find, but it is also extremely expensive. As of 2019, only one bottle could be sourced
                        on the open market and it was priced at €3,250. The 1971 is not for sale.
                        <br><br>
                        Despite it still being very early days after the great man’s demise, his daughters Bruna and
                        Marina who today run the vineyard seem to have inherited the family’s golden DNA. Bruna has been
                        at the helm of the winery since 2006 so we firmly believe her father’s legacy is well looked
                        after.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>2014 Barolo Falletto: this “outstanding” current release is noted for its “Great sense
                                of terroir and typical harmony and style from this producer. A few years will offer
                                greater complexity, as the aromatics are a bit tight as of now. Peak in 15-20 years.” by
                                wine writer Tom Hyland for Forbes, April 2019. In June 2018 Monica Larner for Wine
                                Advocate offered her 95 points. Prices are up +50% in the one year period from February
                                2018, and climbing.
                            </li>
                            <li>Labeled “Riserva” only in the best vintages, Bruno Giacosa’s 1989 Barolo Riserva Collina Rionda was the very first Italian fine wine to receive a “Perfect Score” of 100/100 from the man himself, Robert Parker.
                            </li>
                            <li>Prices historically compared to second growth wines of Bordeaux, Barolo is expected to
                                reclaim its top position for Italian fine wines in the market, as indicated in January
                                2019 by The Drinks Business’ head of trading Paul Regan, who recommends investors “Stick
                                to big names like Giacomo Conterno and Bruno Giacosa and you should do rather well.”
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BrunoGiacosa",
    head: {
        title: 'Bruno Giacosa | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exquisite wine from the legendary Piedmont wine region, made by the renowned winemaker, Bruno Giacosa. Experience the perfect blend of tradition and innovation with each sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {report: 'Giuseppe Mascarello e Figlio', src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'},
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
